import { styled } from '@mui/material/styles';

import ListItem from '@mui/material/ListItem';

const EventInvitationCardMinWrapper = styled(ListItem)`
  justify-content: center;
`;

export default EventInvitationCardMinWrapper;